import { GearIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useGeckoAnalytics } from 'features/analytics'
import { useKestrel, useKestrelViewerContext } from 'features/kestrelViewer'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React, { FC } from 'react'

export const SettingsButton: FC = () => {
  const { settingsOpen, setSettingsOpen } = useKestrelViewerContext()
  const { trackButtonClicked } = useGeckoAnalytics()
  const { kestrelModel } = useKestrel()
  return (
    <TooltipWrapper side={'right'} offset={5} label={'Settings'}>
      <ViewToggle
        onClick={() => {
          setSettingsOpen(!settingsOpen)
          trackButtonClicked({
            button_name: 'kestrel_toggle_settings',
            kestrel_model_id: kestrelModel?.data.kestrel_model_id,
          })
        }}>
        <GearIcon style={{ color: 'white' }} width={22} height={22} />
      </ViewToggle>
    </TooltipWrapper>
  )
}
